import { Button } from '../../../../components/ui/button'
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from '../../../../components/ui/select'
import React, { useState } from 'react'

const DataTablePreset = ({ allJobs, preset, onPresetChange, onExportCSV }) => {
    const [selectedValue, setSelectedValue] = useState('')

    const fieldOptions = {
        "Job Status": ['scheduled', 'open', 'in-progress', 'completed', 'not-anymore'],
        "Payout Status": ['paid', 'failed', 'created', 'manual'],
        "Payment Method": ['stripe', 'paypal', 'applepay'],
        "Shoveller Action": ['canceled', 'accepted', 'pending', 'completed', 'uncompleted'],
        "House Owner Action": ['canceled', 'accepted', 'pending', 'completed']
    }

    const handleFieldChange = (field) => {
        const firstValue = fieldOptions[field]?.[0] || ''
        onPresetChange({ field, value: firstValue })
        setSelectedValue(firstValue)
    }

    const handleValueChange = (value) => {
        setSelectedValue(value)
        onPresetChange({ field: preset.field || preset, value })
    }

    const currentField = preset.field || preset

    return (
        <div className='flex items-end justify-end gap-4'>
            <div className='flex gap-2'>
                <Select value={currentField} onValueChange={handleFieldChange}>
                    <SelectGroup>
                        <SelectLabel>Presets</SelectLabel>
                        <SelectTrigger className='w-40 min-w-fit'>
                            <SelectValue placeholder="Select Field" />
                        </SelectTrigger>
                    </SelectGroup>
                    <SelectContent>
                        <SelectItem value="All Jobs">
                            All Jobs
                        </SelectItem>
                        <SelectItem value="Job Status">
                            Job Status
                        </SelectItem>
                        <SelectItem value="Payout Status">
                            Payout Status
                        </SelectItem>
                        <SelectItem value="Payment Method">
                            Payment Method
                        </SelectItem>
                        <SelectItem value="Shoveller Action">
                            Shoveller Action
                        </SelectItem>
                        <SelectItem value="House Owner Action">
                            House Owner Action
                        </SelectItem>
                    </SelectContent>
                </Select>
                {currentField !== "All Jobs" && (
                    <Select value={selectedValue} onValueChange={handleValueChange}>
                        <SelectGroup>
                            <SelectLabel>Options</SelectLabel>
                            <SelectTrigger className='w-40 min-w-fit'>
                                <SelectValue placeholder="Select Value" />
                            </SelectTrigger>
                        </SelectGroup>
                        <SelectContent>
                            {fieldOptions[currentField]?.map(option => (
                                <SelectItem key={option} value={option}>
                                    {option}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                )}
            </div>
            <Button onClick={() => onExportCSV(allJobs)}>
                Export as CSV
            </Button>
        </div>
    )
}

export default DataTablePreset
